import { FC, ReactElement } from 'react';

interface TooltipWrapperProps {
  tooltip: string;
  children: ReactElement;
  id?: string;
  className?: string;
  position?: 'top' | 'bottom' | 'bottom-left';
  showTooltip?: boolean;
  customTooltipClassName?: string;
  /** When true, tooltip text may wrap; default is single-line (nowrap). */
  allowMultilineTooltip?: boolean;
}

export const TooltipWrapper: FC<TooltipWrapperProps> = ({
  tooltip,
  children,
  id,
  className,
  position = 'top',
  showTooltip = true,
  customTooltipClassName = '',
  allowMultilineTooltip = false
}) => {
  const bodySurfaceClass = allowMultilineTooltip
    ? 'w-[min(260px,calc(100vw-2rem))] break-words px-3 py-2 text-left text-xs leading-snug ' +
      'text-primaryText shadow-md'
    : 'px-2 py-1 text-xs text-primaryText shadow-md';

  return (
    <div className={`group relative ${className}`} id={id}>
      {children}
      {showTooltip && (
        <div
          className={`
          absolute z-20 hidden
          ${allowMultilineTooltip ? '' : 'whitespace-nowrap'}
          rounded bg-white
          ${bodySurfaceClass}
          ${position === 'bottom-left' ? '-bottom-8 translate-x-[-93%]' : 'left-1/2 -translate-x-1/2'}
          ${position === 'top' ? 'bottom-full mb-3' : '-bottom-8'}
          ${position === 'top' ? 'before:top-[100%]' : 'before:bottom-[100%]'}
          ${position === 'top' ? 'before:border-t-white' : 'before:border-b-white'}
          before:absolute
          ${position === 'bottom-left' ? 'before:left-[93%]' : 'before:left-1/2'} 
          ${position === 'bottom-left' ? '' : 'before:-translate-x-1/2'}
          before:border-4
          before:border-x-transparent 
          ${position === 'top' ? 'before:border-b-transparent' : 'before:border-t-transparent'}
          group-hover:block
          ${customTooltipClassName}
        `}
          role="tooltip"
          aria-hidden="true">
          {tooltip}
        </div>
      )}
    </div>
  );
};
